import { Routes } from '@angular/router';
import { HomeLayout } from './layouts/home-layout/home-layout';
import { LoginLayout } from './layouts/login-layout/login-layout';
import { ProductList } from './product/product-list/product-list';
import { ProductPlanDetails } from './product/product-plan-details/product-plan-details';

export const routes: Routes = [
  {
    path: '',
    component: HomeLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./home/home').then((m) => m.Home),
      },
      {
        path: 'home',
        loadComponent: () => import('./home/home').then((m) => m.Home),
      },
      {
        path: 'application-policy-list',
        loadComponent: () =>
          import('./application-policy-list/application-policy-list').then(
            (m) => m.ApplicationPolicyList
          ),
      },
      {
        path: 'application-create',
        loadComponent: () =>
          import('./application-create/application-create').then(
            (m) => m.ApplicationCreateComponent
          ),
      },
      {
        path: 'application-detail/:applicationNo',
        loadComponent: () =>
          import('./application-detail/application-detail').then(
            (m) => m.ApplicationDetailComponent
          ),
      },
      {
        path: 'premium-home',
        loadComponent: () => import('./premium-home/premium-home').then((m) => m.PremiumHome),
      },
      {
        path: 'pay-premium',
        loadComponent: () =>
          import('./pay-premium/pay-premium.component').then((m) => m.PayPremiumComponent),
      },
      {
        path: 'premium-history-list',
        loadComponent: () =>
          import('./premium-history-list/premium-history-list').then((m) => m.PremiumHistoryList),
      },
      {
        path: 'premium-schedule-list',
        loadComponent: () =>
          import('./premium-schedule-list/premium-schedule-list').then(
            (m) => m.PremiumScheduleList
          ),
      },
      {
        path: 'premium-history-detail/:id',
        loadComponent: () =>
          import('./premium-history-detail/premium-history-detail').then(
            (m) => m.PremiumHistoryDetail
          ),
      },
      {
        path: 'pay-premium-from-bonus',
        loadComponent: () =>
          import('./pay-premium-from-bonus/pay-premium-from-bonus').then(
            (m) => m.PayPremiumFromBonus
          ),
      },
      {
        path: 'bonus-cash-back',
        loadComponent: () =>
          import('./components/bonus-cash-back/bonus-cash-back').then((m) => m.BonusCashBack),
      },
      {
        path: 'commission',
        loadComponent: () => import('./components/commission/commission').then((m) => m.Commission),
      },
      {
        path: 'product-interest',
        loadComponent: () =>
          import('./components/product-interest/product-interest').then((m) => m.ProductInterest),
      },
      {
        path: 'hospital-list',
        loadComponent: () =>
          import('./components/hospital-list/hospital-list').then((m) => m.HospitalList),
      },
      {
        path: 'hospital-detail/:id',
        loadComponent: () =>
          import('./components/hospital-detail/hospital-detail').then((m) => m.HospitalDetail),
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile').then((m) => m.Profile),
      },
      {
        path: 'env-debug',
        loadComponent: () =>
          import('./components/env-debug/env-debug.component').then((m) => m.EnvDebugComponent),
      },
      {
        path: 'claim',
        loadComponent: () =>
          import('./claim/i4u-claim-home/i4u-claim-home').then((m) => m.I4uClaimHome),
      },
      {
        path: 'claim/accident-create',
        loadComponent: () =>
          import('./claim/i4u-claim-accident-create/i4u-claim-accident-create').then(
            (m) => m.I4uClaimAccidentCreate
          ),
      },
      {
        path: 'claim/accident-list',
        loadComponent: () =>
          import('./claim/i4u-claim-accident-list/i4u-claim-accident-list').then(
            (m) => m.I4uClaimAccidentList
          ),
      },
      {
        path: 'claim/accident-update/:id',
        loadComponent: () =>
          import('./claim/i4u-claim-accident-update/i4u-claim-accident-update').then(
            (m) => m.I4uClaimAccidentUpdate
          ),
      },
      {
        path: 'claim/dead-create',
        loadComponent: () =>
          import('./claim/i4u-claim-dead-create/i4u-claim-dead-create').then(
            (m) => m.I4uClaimDeadCreate
          ),
      },
      {
        path: 'claim/dead-list',
        loadComponent: () =>
          import('./claim/i4u-claim-dead-list/i4u-claim-dead-list').then((m) => m.I4uClaimDeadList),
      },
      {
        path: 'claim/dead-update/:id',
        loadComponent: () =>
          import('./claim/i4u-claim-dead-update/i4u-claim-dead-update').then(
            (m) => m.I4uClaimDeadUpdate
          ),
      },
      { path: 'I4UProducts', component: ProductList },
      { path: 'I4UProductPlanDetail/:id/:subId', component: ProductPlanDetails },
      {
        path:'policy-cancel',
        loadComponent:() => import('./policy-cancel/policy-cancel-list/policy-cancel-list').then(m => m.PolicyCancelList)
      },
      {
        path:'policy-cancel/create',
        loadComponent:() => import('./policy-cancel/policy-cancel-create/policy-cancel-create').then(m => m.PolicyCancelCreate)
      },
      {
        path:'policy-change-request',
        loadComponent:() => import('./policy-change-request/policy-change-request-list/policy-change-request-list').then(m => m.PolicyChangeRequestList)
      },
      {
        path:'policy-change-request/create',
        loadComponent:() => import('./policy-change-request/policy-change-request-create/policy-change-request-create').then(m => m.PolicyChangeRequestCreate)
      },
      {
        path:'policy-change-request/detail/:id',
        loadComponent:() => import('./policy-change-request/policy-change-request-detail/policy-change-request-detail').then(m => m.PolicyChangeRequestDetail)
      }
    ],
  },
  {
    path: 'login',
    component: LoginLayout,
  },
];
